import OnboardingRadioButton from "../shared/components/formik/radiobutton";
import RadioButtonContainer from "../../ui/layout/page/forms-container/form-item-container/radio-button-container/input-container";
import React from "react";
import { useMessageSource } from "react-message-source";

export const CompanyOwnershipQuestions: React.FC = () => {
  const { getMessage } = useMessageSource();

  return (
    <>
      <RadioButtonContainer>
        <OnboardingRadioButton
          wrap={false}
          title={getMessage(
            "RegulatoryInformation.company-ownership.own-office.title",
          )}
          helper={getMessage(
            "RegulatoryInformation.company-ownership.own-office.sub-title",
          )}
          id="hasOwnOffice"
          name="hasOwnOffice"
          values={[
            {
              id: "has-own-office-no",
              value: false,
              label: getMessage("YesNo.NO"),
            },
            {
              id: "has-own-office-yes",
              value: true,
              label: getMessage("YesNo.YES"),
            },
          ]}
        />
      </RadioButtonContainer>

      <RadioButtonContainer>
        <OnboardingRadioButton
          wrap={false}
          title={getMessage(
            "RegulatoryInformation.company-ownership.own-staff.title",
          )}
          id="employsOwnStaff"
          name="employsOwnStaff"
          values={[
            {
              id: "has-own-staff-no",
              value: false,
              label: getMessage("YesNo.NO"),
            },
            {
              id: "has-own-staff-yes",
              value: true,
              label: getMessage("YesNo.YES"),
            },
          ]}
        />
      </RadioButtonContainer>
    </>
  );
};
